import PropTypes from 'prop-types';
import React from 'react';
import autoBind from 'react-autobind';
import emailValidation from './InputEmail.validation';

import './InputEmail.scss';

class InputEmail extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onChange(event) {
    event.preventDefault();
    if (this.props.validateOnChange) {
      this.validate(event);
    }
    this.props.onChange(event.target.value);
  }

  validate(event) {
    event.preventDefault();
    // const { value = "" } = event.target;
    let isValid = true;
    // if (value !== "") {
    isValid = emailValidation.test(event.target.value);
    // }
    this.props.validate(isValid);
  }

  onFocus() {
    this.props.focus();
  }

  render() {
    const {
      externalClass,
      email,
      placeholder = 'email',
      isAutoFocus,
      id = '',
    } = this.props;

    return (
      <input
        onChange={this.onChange}
        type='email'
        className={externalClass}
        placeholder={placeholder}
        name='email'
        onBlur={this.validate}
        onFocus={this.onFocus}
        value={email}
        autoFocus={isAutoFocus}
        id={id}
      />
    );
  }
}

InputEmail.propTypes = {
  onChange: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  externalClass: PropTypes.string,
  validate: PropTypes.func,
  focus: PropTypes.func,
  validateOnChange: PropTypes.bool,
  placeholder: PropTypes.string,
  isAutoFocus: PropTypes.bool,
  id: PropTypes.string, // For automation tests
};

export default InputEmail;
